export default __webpack_public_path__ + "static/media/arrow-left-blue.a3a8e575.svg";